import { withInstall } from '@vuesax-plus/utils'
import arrow from './src/arrow.vue'

export const IconsArrow = withInstall(arrow)
export default IconsArrow

export * from './src/arrow'
